import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SearchOutlinedStandard.js";
import i from "../components/PfIcon.js";
const r = (t, e) => {
  const a = {
    ...t,
    ...e.attrs
  };
  return n(i, o(a, {
    icon: d
  }), null);
};
r.displayName = "SearchOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
